import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function PropertyIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="24"
        height="18"
        viewBox="0 0 24 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18639_2613)">
          <path
            d="M1.64844 11.6523H12.7725"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.5791 16.3548H10.3872C10.2818 16.3548 10.1808 16.3129 10.1063 16.2384C10.0318 16.1639 9.9899 16.0629 9.9899 15.9575V14.7656H4.42785V15.9575C4.42785 16.0629 4.38599 16.1639 4.31149 16.2384C4.23698 16.3129 4.13593 16.3548 4.03056 16.3548H2.8387C2.73333 16.3548 2.63228 16.3129 2.55777 16.2384C2.48326 16.1639 2.44141 16.0629 2.44141 15.9575V11.5873L3.92578 8.24761C3.95699 8.17739 4.0079 8.11774 4.07234 8.07587C4.13677 8.034 4.21196 8.01172 4.2888 8.01172H10.1289C10.2058 8.01172 10.281 8.034 10.3454 8.07587C10.4098 8.11774 10.4608 8.17739 10.492 8.24761L11.9763 11.5873V15.9575C11.9763 16.0629 11.9345 16.1639 11.86 16.2384C11.7855 16.3129 11.6844 16.3548 11.5791 16.3548Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.2148 16.355L22.3464 16.355"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.2148 1.88086L11.2261 5.22119"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.2344 16.3549V1.88086"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.9961 4.66406H15.1095"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.3359 4.66406H18.4493"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.9961 7.44775H15.1095"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.3359 7.44775H18.4493"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.3359 10.2314H18.4493"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5508 16.3543V13.0142H17.8909V16.3543"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.0977 1.88086H22.3449"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_18639_2613">
            <rect
              width="23.3812"
              height="16.7008"
              fill="white"
              transform="translate(0.308594 0.649414)"
            />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
